import {utils} from "../utils";
import {CSRF_TOKEN} from "../constants";

/** Класс запросов к серверу */
export class Api {
	/**
	 * Состояние корзины
	 * @return {Promise}
	 */
	getCartCount(event_id = 0) {
		return utils.request(
			"/event/cart/get-cart",
			{"_csrf-frontend": CSRF_TOKEN, event_id},
			"POST",
			true,
			false
		);
	}

	/**
	 * Цены мероприятия
	 * @return {Promise}
	 */
	getPrices(event_id, view_id, needOverlay) {
		return utils.request(
			"/event/get-prices",
			{
				"_csrf-frontend": CSRF_TOKEN,
				event_id,
				view_id,
			},
			"POST",
			true,
			needOverlay
		);
	}

	/**
	 * Добавление в корзину
	 * @return {Promise}
	 */
	addToCart(event_id, sid) {
		return utils.request("/event/cart/add", {
			"_csrf-frontend": CSRF_TOKEN,
			event_id,
			sid,
			view_id: window.currentViewId,
		});
	}

	/**
	 * Добавление в корзину для 2 планов
	 * @return {Promise}
	 */
	splitAddToCart(event_id, sid) {
		return utils.request("/splitcart/add", {
			event_id,
			sid,
		});
	}

	/**
	 * Удаление из корзины
	 * @return {Promise}
	 */
	removeFromCart(event_id, sid, uid) {
		return utils.request(
			"/event/cart/remove",
			{
				"_csrf-frontend": CSRF_TOKEN,
				event_id,
				sid,
				uid,
				view_id: window.currentViewId,
			},
			"DELETE"
		);
	}

	/**
	 * Получение svg мероприятия
	 * @return {Promise}
	 */
	getSvg(event_id, view_id, needOverlay) {
		return utils.request(
			"/event/get-svg",
			{
				"_csrf-frontend": CSRF_TOKEN,
				event_id,
				view_id,
			},
			"POST",
			true,
			needOverlay
		);
	}

	/**
	 * Получение svg мероприятия и цены
	 * @return {Promise}
	 */
	getSvgPrices(event_id, view_id, needOverlay) {
		return utils.request(
			"/event/get-svg-prices",
			{
				"_csrf-frontend": CSRF_TOKEN,
				event_id,
				view_id,
			},
			"POST",
			true,
			needOverlay
		);
	}

	/**
	 * Отмена промокода
	 * @return {Promise}
	 */
	cancelPromocode(order_id, code) {
		return utils.request(`/promo/cancel`, {
			order_id,
			code,
		});
	}

	/**
	 * Применение промокода
	 * @return {Promise}
	 */
	setPromocode(order_id, code) {
		return utils.request(`/promo/apply`, {
			order_id,
			code,
		});
	}

	/**
	 * Получение бонусов
	 * @return {Promise}
	 */
	getBonuses() {
		return utils.request("/loyalty/get-bonuses", null, "GET", true, false, true, 30000);
	}

	/**
	 * Получение бонусов для заказа
	 * @param order_id {Number} - id заказа
	 * @return {Promise}
	 */
	getOrderBonuses(order_id) {
		return utils.request(
			"/loyalty/get-bonuses-by-order",
			{
				order_id,
			},
			"GET"
		);
	}

	/**
	 * Списание бонусов
	 * @param order_id {Number} - id заказа
	 * @param bonuses {Number} - Количество бонусов
	 * @return {Promise}
	 */
	payWithBonuses(order_id, bonuses) {
		return utils.request(
			"/loyalty/distribution-bonuses/",
			{
				order_id,
				bonuses,
			},
			"GET"
		);
	}

	/**
	 * Возврат бонусов
	 * @param order_id {Number} - id заказа
	 * @return {Promise}
	 */
	undistributionBonuses(order_id) {
		return utils.request(
			"/loyalty/undistribution-bonuses/",
			{
				order_id,
			},
			"GET",
			true,
			true
		);
	}

	/**
	 * Поиск
	 * @return {Promise}
	 */
	search(data) {
		return utils.request("/search", data, "GET");
	}

	/**
	 * Удалить заказ
	 * @return {Promise}
	 */
	cancelOrder(id) {
		return utils.request(`/order/cancel?id=${id}`);
	}

	/**
	 * Удалить мероприятия из заказа
	 * @return {Promise}
	 */
	removeEventFromOrder(event_id, order_id) {
		return utils.request(`/event/cart/remove-event`, {event_id, order_id});
	}

	getSubscriptionCartCount(event_id, sub_event_id, needOverlay = false) {
		return utils.request(
			`/subscription-cart/get-cart/${event_id}/${sub_event_id}`,
			null,
			"POST",
			true,
			needOverlay
		);
	}

	addToSubscriptionCart(event_id, sub_event_id, sid) {
		return utils.request(`/subscription-cart/add-to-cart/${event_id}/${sub_event_id}`, {
			sid,
		});
	}

	removeFromSubscriptionCart(event_id, sub_event_id, sid) {
		return utils.request(`/subscription-cart/remove-from-cart/${event_id}/${sub_event_id}`, {
			sid,
		});
	}

	addEvent(event_id, sub_event_id) {
		return utils.request(`/subscription-cart/add-event/${event_id}/${sub_event_id}`);
	}

	removeEvent(event_id, sub_event_id) {
		return utils.request(`/subscription-cart/remove-event/${event_id}/${sub_event_id}`);
	}

	addAllEvents(event_id) {
		return utils.request(`/subscription-cart/add-events/${event_id}`);
	}

	removeAllEvents(event_id) {
		return utils.request(`/subscription-cart/remove-events/${event_id}`);
	}

	removeEventSids(event_id, sub_event_id) {
		return utils.request(`/subscription-cart/remove-event-sids/${event_id}/${sub_event_id}`);
	}

	getPlaces(event_id) {
		return utils.request(
			"/event/get-places",
			{
				event_id,
			},
			"GET"
		);
	}

	getPlacesSvg(event_id, view_id) {
		return utils.request(
			"/event/get-svg",
			{
				event_id,
				view_id,
			},
			"POST"
		);
	}

	getSubscriptionPlace(event_id, sub_event_id) {
		return utils.request(
			`/subscription/place/`,
			{
				event_id,
				sub_event_id,
			},
			"GET",
			false
		);
	}

	getSubscriptionChange(event_id, name) {
		return utils.request(
			`/subscription/change/`,
			{
				event_id,
				name,
			},
			"GET",
			false
		);
	}

	getChangeSeats(event_id, sub_event_id) {
		return utils.request(`/subscription-cart/move-event-carts/${event_id}/${sub_event_id}`);
	}

	getAllDictionary(lang) {
		return utils.request(
			`/language/get-all-dictionary?lang=${lang}`,
			null,
			"GET",
			true,
			false,
			true
		);
	}

	splitAdd(event_id, sid) {
		return utils.request(
			"/split-cart/add",
			{
				event_id,
				sid,
			},
			"POST"
		);
	}

	splitRemove(event_id, sid) {
		return utils.request(
			"/split-cart/remove",
			{
				event_id,
				sid,
			},
			"POST"
		);
	}

	splitGetViews() {
		return utils.request("/split/get-views", {}, "GET");
	}

	deleteServiceTicket(serviceId, uid) {
		return utils.request(
			"/service/cart/remove",
			{
				service_id: serviceId,
				uid,
			},
			"DELETE"
		);
	}

	deleteServiceFromOrder(service_id, count) {
		return utils.request(
			"/service/cart/scope-remove",
			{
				service_id,
				count,
			},
			"DELETE"
		);
	}

	getZones(event_id) {
		return utils.request(`/event/get-zones/?event_id=${event_id}`, {}, "GET");
	}

	removeFullCart() {
		return utils.request("/order/cancel-all");
	}

	/**
	 * Подписывается на матч
	 */
	subscribeToEvent(event_id) {
		return utils.request(`mail-subscription/add`, {event_id}, "GET");
	}

	/**
	 * Отписывается от матча
	 */
	unsubscribeToEvent(event_id) {
		return utils.request(`mail-subscription/remove`, {event_id}, "GET");
	}

	/**
	 * Проверяет подписку на матч
	 */
	checkSubscribeOfEvent(event_id) {
		return utils.request(`mail-subscription/has-subscription`, {event_id}, "GET", true, false);
	}

	/**
	 * Возврат билетов
	 */
	ticketReturn(order_id, event_id) {
		return utils.request("refund", {order_id, event_id});
	}
}
